// 有洁癖  search相关放这里
export const formContent = [
    {
        id: 2,
        text: $t('integration.monitoring_point'),
        type: 'input',
        paramsName: 'carrierName',
        isChooze: false
    },
    {
        id: 3,
        text: $t('integration.time'),
        type: 'datetimerange',
        paramsName: 'time',
        isChooze: false
    },
    {
        id: 1,
        text: 'labelTitle.Range',
        type: 'select',
        paramsName: 'sceneId',
        selectParam: [],
        isChooze: true
    }
];

// 搜索提交上去的数据
export const searchForm = {
    carrierName: undefined,
    sceneId: '',
    time: [],
    iDisplayStart: 0,
    iDisplayLength: 15
};

// 操作按钮
export const operationBtn = [
    {
        id: 1,
        icon: '',
        text: 'integration.handle',
        method: 'batchHandleFn'
    },
    {
        id: 2,
        icon: '',
        text: 'integration.delete',
        method: 'deleteFn'
    }
];
